import React from 'react';
import { trackEventEditAd } from 'common/lib/helpers/trackingService';
import { AD_CREATED, AD_READY, CDN_IMAGE_SRC } from 'common/lib/helpers/constants';
import PropTypes from 'prop-types';

const ImproveVisibilityPanel = ({ finnkode, unitFinnkode, adStatus, orgId, layoutPath }) => {
    const adUrl = `${layoutPath}/admin/form/input?orgId=${orgId}&finnkode=${unitFinnkode || finnkode}`;
    const statsUrl = `${layoutPath}/effekt/${finnkode}?orgId=${orgId}`;
    const marketingUrl = `${layoutPath}/admin/buyMarketing?orgId=${orgId}&finnkode=${finnkode}`;

    return (
        <div className="inline-grid gap-16 grid-cols-2 bg-bluegray-100 w-full p-32">
            <div>
                <h3 className="truncate text-28 gray-700">Dette er din annonse</h3>
                <a
                    href={adUrl}
                    className="link mr-16"
                    onClick={() => {
                        trackEventEditAd();
                    }}
                >
                    Endre annonsen
                </a>
                {adStatus !== AD_CREATED && adStatus !== AD_READY && <a href={statsUrl}>Se statistikk</a>}
            </div>
            <div className="flex gap-16">
                <img src={`${CDN_IMAGE_SRC}/icon-rocket.svg`} alt="Rakett ikon" />
                <div>
                    <h4>Nå flere potensielle kjøpere med din annonse</h4>
                    <a className="button button--secondary" href={marketingUrl}>
                        Øk din synlighet
                    </a>
                </div>
            </div>
        </div>
    );
};

ImproveVisibilityPanel.propTypes = {
    finnkode: PropTypes.number.isRequired,
    unitFinnkode: PropTypes.number,
    adStatus: PropTypes.string.isRequired,
    orgId: PropTypes.number.isRequired,
    layoutPath: PropTypes.string.isRequired,
};

export default ImproveVisibilityPanel;
